export default __webpack_public_path__ + "static/media/icon-arrow-purple.10ef0e8b.svg";